module.exports = __webpack_public_path__ + "static/2front-about-people-1-a4d8479a9bfb991cb2396a8ccc68dc1f.png";